/* eslint-disable quotes */
import { h } from 'vue';
import { vimeo } from '../../vimeo';

const body = `<h4>Dissolve patches</h4>

<p>Dissolve selected adjacent patches (faces).</p>

<div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="${vimeo('556486652')}" loading="lazy"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
</div>



<ul class='shortcuts'>
    <li class='shortcuts__item'><b>Shortcuts:</b></li>
    <li class='shortcuts__item'>No shortcuts for this operation</li>
</ul>`;

export default function DissolveTooltip() {
    return h('div', { innerHTML: body });
}
